import { createSlice } from "@reduxjs/toolkit";




const initialState = {
  allState: {},
  rowIcons: [],
  allDataApis: {},
  isLoadingApis: false,
  isToggle: true,
  isOpenUpload: false,
  isUploadFileTable: false,
  refresh: false,
  reportType: null,
}


export const tableSlice = createSlice({
  name: "generaltable",
  initialState,
  reducers: {
    setTable: (state, action) => {
      const { option, value } = action.payload;
      state[option] = value;
    },
    toggleRefresh: (state) => {
      state.refresh = !state.refresh;
    },
    resetTable: () => initialState
  },
});

export const { setTable, toggleRefresh, resetTable } = tableSlice.actions; 
export default tableSlice.reducer;
